export default function (http) {
    return {
        queryByPage (data){
            return http.json({
                url: `/order/log/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },
        getInfo (data){
            return http.json({
                url: `/order/log/get?id=${data.id}`,
                data
            })
        },
        saveInfo (data){
            return http.json({
                url: `/order/log/save`,
                data
            })
        },
        delete (data){
            return http.json({
                url: `/order/log/delete`,
                data
            })
        },
        queryAll (data){
            return http.json({
                url: '/order/log/queryAll',
                data
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/orderLog.js